export const REQUEST_QUOTE_VALUE = 'REQUEST_QUOTE';
export const CART_AND_BUY_VALUE = 'CART_AND_BUY';
export const QUOTE_AND_CART_VALUE = 'QUOTE_AND_CART';

export const DEFAULT_VALUE = QUOTE_AND_CART_VALUE;
